// Validate email format
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validate required field
export const validateRequired = (value) => {
  return value && value.toString().trim().length > 0;
};

// Validate minimum length
export const validateMinLength = (value, minLength) => {
  return value && value.toString().length >= minLength;
};

// Validate maximum length
export const validateMaxLength = (value, maxLength) => {
  return value && value.toString().length <= maxLength;
};

// Validate number range
export const validateNumberRange = (value, min, max) => {
  const num = Number(value);
  return !isNaN(num) && num >= min && num <= max;
};

// Validate task data
export const validateTask = (task) => {
  const errors = {};

  if (!validateRequired(task.title)) {
    errors.title = 'Название задачи обязательно';
  }

  if (!validateRequired(task.description)) {
    errors.description = 'Описание задачи обязательно';
  }

  if (task.hours <= 0) {
    errors.hours = 'Количество часов должно быть больше нуля';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Validate login form
export const validateLogin = (credentials) => {
  const errors = {};

  if (!validateRequired(credentials.username)) {
    errors.username = 'Имя пользователя обязательно';
  }

  if (!validateRequired(credentials.password)) {
    errors.password = 'Пароль обязателен';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Validate registration form
export const validateRegistration = (form) => {
  const errors = {};

  // Email validation
  if (!validateRequired(form.email)) {
    errors.email = 'Email обязателен';
  } else if (!validateEmail(form.email)) {
    errors.email = 'Введите корректный email';
  }

  // Password validation
  if (!validateRequired(form.password)) {
    errors.password = 'Пароль обязателен';
  } else if (!validateMinLength(form.password, 6)) {
    errors.password = 'Пароль должен содержать минимум 6 символов';
  }

  // Confirm password validation
  if (!validateRequired(form.confirmPassword)) {
    errors.confirmPassword = 'Подтверждение пароля обязательно';
  } else if (form.password !== form.confirmPassword) {
    errors.confirmPassword = 'Пароли не совпадают';
  }

  // Name validation
  if (!validateRequired(form.lastName)) {
    errors.lastName = 'Фамилия обязательна';
  } else if (!validateMinLength(form.lastName, 2)) {
    errors.lastName = 'Фамилия должна содержать минимум 2 символа';
  }

  if (!validateRequired(form.firstName)) {
    errors.firstName = 'Имя обязательно';
  } else if (!validateMinLength(form.firstName, 2)) {
    errors.firstName = 'Имя должно содержать минимум 2 символа';
  }

  // Position validation
  if (!validateRequired(form.position)) {
    errors.position = 'Должность обязательна';
  } else if (!validateMinLength(form.position, 2)) {
    errors.position = 'Должность должна содержать минимум 2 символа';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
}; 